module.exports = __webpack_public_path__ + "img/icon_ho_bg_bottom.b8f2526b.png";